import React, { Component } from 'react'
import { Route, Switch } from 'react-router-dom'
import { baseUrl } from '../config/endpoints'
import modules from '../config/modules'
import { MessageCard } from 'tr-components/MessageCard'

export default class Routes extends Component {
  render() {
    return (
      <Route
        path={`${baseUrl}/clients/:clientId`}
        render={({ match }) => (
          <Switch>
            {modules.map((module) => module.getRoutes(match.path))}
            <Route
              render={() => (
                <MessageCard title="404 not found" message="Sorry, that page does not exist." />
              )}
            />
          </Switch>
        )}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/Routes.js